import React from "react";
import '../../../assets/sass/components/feedback/loading-overlay.scss';
import {CircularSpinner} from "../spinner/Spinner";

const LoadingOverlay = props => {
    const text = props.text || "Please wait. While we fetch the results";

    return (
        <div className="feedback-loading-overlay">
            <CircularSpinner show={true} className="feedback-loading-overlay--spinner"/>
            <div className="feedback-loading-overlay--text"> {text} </div>
        </div>
    );
};

export default LoadingOverlay;
